var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("欢迎使用山东星驰泰和拍卖系统")]),_c('h1',[_vm._v("如在使用中遇到任何问题,请联系")])])
}]

export { render, staticRenderFns }